import { CountyData } from "../CountyData";
import GreenCounty from "./GreenCounty";
import NotGreenCounty from "./NotGreenCounty";

function CountyCard({ county }) {
  const isGreen = CountyData[county].isGreen;
  const capitalCounty = county.charAt(0).toUpperCase() + county.slice(1);

  return (
    <div className="col-md-3 card main-card county-card p-0 mb-10">
      <h5 className="card-header text-secondary">{capitalCounty} County</h5>
      {isGreen ? (
        <GreenCounty county={county} />
      ) : (
        <NotGreenCounty county={county} />
      )}
    </div>
  );
}

export default CountyCard;
